<script>

import { API_EMPLOYEE } from '../../common/api'
import EmployeeSelect from '../../components/EmployeeSelect'

export default {
  name: 'EmployeeCommon',
  data () {
    return {
      employeeForm: {
        name: '',
        mobile: '',
        password: '',
        role_id: null
      },
      rules: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        role_id: [
          { required: true, message: '角色不能为空', trigger: 'blur' }
        ],
      },
    }
  },
  create () {

  },
  methods: {
    roleChange (role) {
      this.employeeForm.role_id = role
    }
  },
  components: {
    EmployeeSelect
  }
}
</script>

<template>
  <div>
    <el-form ref="employeeForm" :model="employeeForm" :rules="rules" size="small" @submit.native.prevent label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="employeeForm.name" placeholder="请输入姓名" clearable class="form_input_width"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="employeeForm.mobile" placeholder="请输入手机号" clearable class="form_input_width"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="employeeForm.password" placeholder="请输入密码" clearable class="form_input_width"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role_id">
          <EmployeeSelect :defaultValue="employeeForm.role_id" @roleChange="roleChange" style="width: 350px;"></EmployeeSelect>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="resetForm('employeeForm')" size="small">重 置</el-button>
          <el-button type="primary" @click="submitForm('employeeForm')" size="small">确 定</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<style lang="scss" scoped>

@import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/employee/EmployeeCommon.vue